export const isPreview = (viewMode: string): boolean => viewMode === 'Preview';
